/*
* Angular module to handle OutOfOffice Settings under MyAccount> Profile
*/
angular.module('App.MyAccount.OutOfOffice.Ctrl',[])

.filter('yesNo', function(){
    return function(str){
        return str === 'true' ? i18n.YES: i18n.NO;
    };
})

.controller('myAccountOutOfOfficeSettingsCtrl', ['$scope', 'myAccountProfileSvc', '$log', '$rootScope',
    function ($scope, myAccountProfileSvc, $log, $rootScope) {
        $scope.myAccount = $scope.myAccount || {};
        $scope.myAccount.outOfOffice = {
            edit: false
        };

        $scope.myAccount.outOfOffice.get = function() {
            $scope.flags.loading = true;
            myAccountProfileSvc.getOutOfOfficeSetting(function(response) {
                $scope.myAccount.outOfOffice.edit = false;
                $scope.flags.loading = false;
                $scope.myAccount.outOfOffice.data = response.isUserOutOfOffice + '';
                $rootScope.isUserOutOfOffice = response.isUserOutOfOffice;
                $scope.myAccount.outOfOffice.dataCopy = angular.copy($scope.myAccount.outOfOffice.data);
            }, function(err){
                $scope.flags.loading = false;
                $log.error(err);
            });
        };

        $scope.myAccount.outOfOffice.cancel = function() {
            $scope.myAccount.outOfOffice.data = angular.copy($scope.myAccount.outOfOffice.dataCopy);
            $scope.myAccount.outOfOffice.edit = false;
            $scope.myAccount.outOfOffice.alternateApproverMissing = false;
        };

        $scope.myAccount.outOfOffice.save = function() {
            var data = {
                userAvailable: ($scope.myAccount.outOfOffice.data === 'true')
            };
            if(data.userAvailable && !$scope.isAlternateApproversExists) {
               $scope.myAccount.outOfOffice.alternateApproverMissing = true;
            } else {
                myAccountProfileSvc.saveOutOfOfficeSetting(data, function(response){
                     $scope.flags.loading = false;
                     if(response.msgInfo === 200) {
                        $scope.showMsg('DATA_SAVED');
                        //$scope.myAccount.outOfOffice.get();
                        $scope.myAccount.outOfOffice.edit = false;
                        $scope.myAccount.outOfOffice.data = data.userAvailable + '';
                        $rootScope.isUserOutOfOffice = data.userAvailable;
                        $scope.myAccount.outOfOffice.dataCopy = angular.copy($scope.myAccount.outOfOffice.data);
                    }
                }, function(err){
                    $scope.flags.loading = false;
                    $log.error(err);
                });
            }
        };

        $scope.myAccount.outOfOffice.broadcastToApprover = function() {
            $scope.myAccount.outOfOffice.edit = false;
            $scope.myAccount.outOfOffice.alternateApproverMissing = false;
            $rootScope.$emit('changeApprover', {});
        };

        $rootScope.$on('cancelSettingApprover', function(){
            $scope.myAccount.outOfOffice.cancel();
        });

        $rootScope.$on('approverSaved', function(event, data){
            $scope.myAccount.outOfOffice.data = data;
            $scope.myAccount.outOfOffice.save();
        });

        $scope.myAccount.outOfOffice.get();
    }
]);